export default [
    function () {
        return {
            restrict: 'EA',
            scope: {
                contact: '=eeeContact',
                colored: '=eeeColored',
            },
            template: `
                <span class="message-name"
                    ng-style="colored && {'color': contact.color}"
                       ng-bind-html="contact | displayName | escapeHtml | emojify">
                </span>
            `,
        };
    },
];
